import { Dispatch } from "../types/types";
import { request } from "../helpers/httpInterceptor";
import h from "../helpers";
import {
    SET_SAA_ADVERTISER_LIST,
    SET_LOADING_SAA_ADVERTISERS,
    SET_SAVING_SAA_ADVERTISER,
    SET_SELECTED_SAA_ADVERTISER,
} from "../reducers/saaAdvertisers";
import {
    ISetSAAAdvertisersList,
    ISetLoadingSAAAdvertiserList,
    ISetSavingSAAAdvertiser,
    ISetSelectedSAAAdvertiser,
    ISAAAdvertiser,
} from "../types/stores/saaAdvertisers";
import { notifyGreen } from "./notifyActions";

export const setSAAAdvertisersList = (saaAdvertiserList: Array<ISAAAdvertiser>): ISetSAAAdvertisersList => ({
    type: SET_SAA_ADVERTISER_LIST,
    saaAdvertiserList,
});

export const setLoadingSAAAdvertisersList = (isLoadingList: boolean): ISetLoadingSAAAdvertiserList => ({
    type: SET_LOADING_SAA_ADVERTISERS,
    isLoadingList,
});

export const setSavingSAAAdvertiser = (isSaving: boolean): ISetSavingSAAAdvertiser => ({
    type: SET_SAVING_SAA_ADVERTISER,
    isSaving,
});

export const setSelectedSAAAdvertiser = (selectedId: number): ISetSelectedSAAAdvertiser => ({
    type: SET_SELECTED_SAA_ADVERTISER,
    selectedId,
});

export const getSAAAdvertiserList =
    () =>
    (dispatch: Dispatch): void => {
        dispatch(setLoadingSAAAdvertisersList(true));

        request("/SAAAdvertiser/GetAllAdvertisers", { credentials: "same-origin" }, dispatch)
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const result = data as unknown as { advertisers: Array<ISAAAdvertiser> };
                dispatch(setSAAAdvertisersList(result.advertisers));
                dispatch(setLoadingSAAAdvertisersList(false));
            })
            .catch(error => {
                dispatch(setSAAAdvertisersList([]));
                dispatch(setLoadingSAAAdvertisersList(false));
                h.error("Error getting SAA Advertiser List.", error);
            });
    };

export const addSAAAdvertiser =
    (advertiser: ISAAAdvertiser) =>
    (dispatch: Dispatch): void => {
        dispatch(setSavingSAAAdvertiser(true));
        request(
            "/SAAAdvertiser/AddAdvertiser",
            {
                credentials: "same-origin",
                method: "POST",
                body: JSON.stringify(advertiser),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(setSavingSAAAdvertiser(false));
                dispatch(setSelectedSAAAdvertiser(0));
                dispatch(notifyGreen("New SAA Advertiser Added."));
            })
            .catch(error => {
                dispatch(setSavingSAAAdvertiser(false));
                h.error("Error adding SAA Advertiser.", error);
            });
    };

export const updateSAAAdvertiser =
    (advertiser: ISAAAdvertiser) =>
    (dispatch: Dispatch): void => {
        dispatch(setSavingSAAAdvertiser(true));
        request(
            "/SAAAdvertiser/UpdateAdvertiser",
            {
                credentials: "same-origin",
                method: "POST",
                body: JSON.stringify(advertiser),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(setSavingSAAAdvertiser(false));
                dispatch(setSelectedSAAAdvertiser(0));
                dispatch(notifyGreen("SAA Advertiser Updated."));
            })
            .catch(error => {
                dispatch(setSavingSAAAdvertiser(false));
                h.error("Error updating SAA Advertiser.", error);
            });
    };

export const deleteSAAAdvertiser =
    (advertiserId: number) =>
    (dispatch: Dispatch): void => {
        dispatch(setSavingSAAAdvertiser(true));
        request(
            "/SAAAdvertiser/DeleteAdvertiser?advertiserId=" + advertiserId,
            {
                credentials: "same-origin",
                method: "POST",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(getSAAAdvertiserList());
                dispatch(setSavingSAAAdvertiser(false));
                dispatch(setSelectedSAAAdvertiser(0));
                dispatch(notifyGreen("SAA Advertiser Deleted."));
            })
            .catch(error => {
                dispatch(getSAAAdvertiserList());
                dispatch(setSavingSAAAdvertiser(false));
                h.error("Error deleting SAA Advertiser.", error);
            });
    };

export const getSAATapadDeliveryTemplates =
    (companyId: number) =>
    (dispatch: Dispatch): void => {
        dispatch(setSavingSAAAdvertiser(true));
        request(
            "/SAAAdvertiser/GetSAATapadDeliveryTemplates?companyId=" + companyId,
            {
                credentials: "same-origin",
                method: "POST",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then((data: { saaTapadDeliveryTypes: any }) => {
                if (data.saaTapadDeliveryTypes) {
                    dispatch({
                        type: "SET_SAA_TAPAD_DELIVERY_TYPES",
                        saaTapadDeliveryTypes: data.saaTapadDeliveryTypes,
                    });
                }
            })
            .catch(error => {
                dispatch(setSavingSAAAdvertiser(false));
                h.error("Error updating SAA Advertiser.", error);
            });
    };
